<template>
  <div class="main-container">
    <breadcrumb
        main_step_name="Organisation"
        sub_step_name="Utilities"
        step_name="Manage Financial year"
        @goToMainStep="routeToMainStep"
        @goToSubStep="routeToSubStep"
      />
    <tl-header type="h1" class="margintop-20">Manage Financial Year</tl-header>
    <div class="label-text">Manage Financial Year</div>

    <toast-message :message="errmsg" type="error" :isToastEnable="toast"  @close ="(val) => toast = val"/>

    <div class="inline-radio margintop-10">
      <tl-radio
        label="Activate FY"
        name="financialYear"
        id="activateFY"
        value="activateFY"
        v-model="financialYearType"
      ></tl-radio>
      <tl-radio
        label="Switch FY"
        name="financialYear"
        id="switchFY"
        class="marginleft-5p"
        value="switchFY"
        v-model="financialYearType"
      ></tl-radio>
    </div>
    <div class="singleColumnGrid margintop-20">
      <txt
        v-if="financialYearType == 'activateFY'"
        label="Coming Financial Year"
        name="comingFinancialYear"
        placeholder="2020-2021"
        class="marginbot-20"
        disabled = true
        v-model="commingFinancialYear"
      />
      <!-- <tl-select
        v-if="financialYearType == 'switchFY'"
        label="Switch Financial Year"
        labelText="financialYear"
        :options="financialYearList"
      ></tl-select> -->
      <tl-select v-if="financialYearType == 'switchFY'" label="Switch Financial Year" labelText="name" :options="globalDataObj.FinancialYear"
              v-model="financialYearObj" @change="(val) => financialYearObj = val"></tl-select>
    </div>
    <div class="group-btn margintop-20" v-if="financialYearType">
      <btn-grp>
        <btn text="Cancel" type="secondary" />
        <btn
          v-if="financialYearType == 'activateFY'"
          text="Activate"
          type="primary"
          v-on:click="activateFinancialYear"
        ></btn>
        <btn
          v-if="financialYearType == 'switchFY'"
          text="Switch"
          type="primary"
          v-on:click="switchFinancialYear"
        ></btn>
      </btn-grp>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Financial Year ${financialYearObj.name} has been successfully Switched.`"
      btnText="Back To Organisation"
      @back="backfrompopup()"
    />
    <pop-up-message
      v-if="showActivateFYSuccessMsg"
      :message="`Financial Year 2012-21 has been successfully Activated.`"
      btnText="Back To Organisation"
      @back="backfrompopup()"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "ManageFinancialYear",
  computed: {
    ...mapState({
      globalDataObj: state => state.globalapi.globalData.data
    }),
    ...mapGetters({
      orgid: "onboard/organization/orgid",
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),

    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    }
  },
  data() {
    return {
      toast: false,
      errmsg: "",
      commingFinancialYear:"2020-21",
      financialYearObj: {},
      financialYearType: "activateFY",
      showSuccessMsg: false,
      showActivateFYSuccessMsg: false,
      financialYearList: [
        {
          financialYear: "2019-2020",
          value: "2019-2020"
        },
        {
          financialYear: "2020-2021",
          value: "2020-2021"
        },
        {
          financialYear: "2021-2022",
          value: "2021-2022"
        }
      ]
    };
  },
  methods: {
    ...mapActions({
      act_create: "dashboard/organisation/utilities/managefinancialyear/create"
    }),

    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },
    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },

    async switchFinancialYear() {
      let obj = {
        data: {
          le_id: this.leId,
          financialYearId: this.financialYearObj.id,
          name: this.financialYearObj.name,
          displayName: this.financialYearObj.name,
          status: true,
        }
      };

      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj);
        //console.log("switchFinancialYear", res);
        setTimeout(() => {
          if (res.status == 200 || res.status == 201) {
            this.showSuccessMsg = true;
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        //console.log("error", error);
        this.$root._data.isSaving = false;
        this.errmsg = error;
        this.toast = true;
      }
    },

    async activateFinancialYear() {

      let obj = {
        data: {
          le_id: this.leId,
          //financialYearId: this.financialYearObj.id,
          name: this.commingFinancialYear,
          displayName: this.commingFinancialYear,
          status: true
        }
      };

      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj);
        //console.log("switchFinancialYear", res);
        setTimeout(() => {
          if (res.status == 200 || res.status == 201) {
            this.showActivateFYSuccessMsg = true;
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        //console.log("error", error);
        this.errmsg = error;
        this.toast = true;
      }
    },

    backfrompopup() {
      this.showSuccessMsg = false;
      this.showActivateFYSuccessMsg = false;
      this.commingFinancialYear = "";
      this.financialYearObj = {};
      this.$router.push({ path: "/dashboard" });
    }
  }
};
</script>
<style lang="scss" scoped>
.inline-radio {
  display: flex;
}
</style>
